// Line-style icons for the SGOKit platform site. Civic/instrument register to
// match Public Sans + Space Mono, distinct from OCEN's tenant-site icons.tsx.
import React from 'react';

type P = { size?: number };
const base = (size: number) => ({
  width: size, height: size, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.6, strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

// Donations — heart held in an open hand
export const IcoDonations = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M3 20h4l7 1c1.3 0 2-1.4 1-2l-3-2" /><path d="M3 14v6" /><path d="M15 6.5c-1-1.6-3.4-1.4-4 .4-.6-1.8-3-2-4-.4-.7 1.2 0 2.5 1 3.4L15 13l3-3.1c1-.9 1.7-2.2 1-3.4-1-1.6-3-1-4 0z" /></svg>
);
// Applications — document with a check
export const IcoApplications = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8z" /><path d="M14 3v5h5" /><path d="M8.5 14.5l2 2 4-4.5" /></svg>
);
// Scoring — target with a rising bar
export const IcoScoring = ({ size = 24 }: P) => (
  <svg {...base(size)}><circle cx="9" cy="12" r="6" /><circle cx="9" cy="12" r="2.4" /><path d="M17 20v-6M20 20v-9M14 20v-3" /></svg>
);
// Disbursement — funds sent outward
export const IcoDisbursement = ({ size = 24 }: P) => (
  <svg {...base(size)}><circle cx="7" cy="12" r="3.4" /><path d="M13 8h7M13 12h7M13 16h7" /><path d="M17.5 6l2.5 2-2.5 2" /></svg>
);
// Compliance — shield with a check
export const IcoCompliance = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M12 3l7 2.5v5c0 5-3.4 8-7 10-3.6-2-7-5-7-10v-5z" /><path d="M9 12l2 2 4-4" /></svg>
);
// Footprint — map tiles / pin
export const IcoFootprint = ({ size = 24 }: P) => (
  <svg {...base(size)}><rect x="3.5" y="3.5" width="7" height="7" rx="1.2" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.2" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.2" /><path d="M17 13.5c-2 0-3.5 1.5-3.5 3.4 0 2 3.5 4.1 3.5 4.1s3.5-2.1 3.5-4.1c0-1.9-1.5-3.4-3.5-3.4z" /><circle cx="17" cy="16.7" r="1" /></svg>
);
// Site — browser window
export const IcoSite = ({ size = 24 }: P) => (
  <svg {...base(size)}><rect x="3" y="4" width="18" height="16" rx="1.5" /><path d="M3 8h18" /><circle cx="6" cy="6" r=".6" fill="currentColor" /><circle cx="8" cy="6" r=".6" fill="currentColor" /><path d="M7 12h5M7 15h8" /></svg>
);
// Theming — palette / swatches
export const IcoTheming = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M12 3a9 9 0 1 0 0 18c1.4 0 2-1 2-2s-.7-1.5-.7-2.3c0-.9.8-1.7 1.7-1.7H18a3 3 0 0 0 3-3c0-4.6-4-9-9-9z" /><circle cx="8" cy="12" r="1.1" fill="currentColor" /><circle cx="9.5" cy="8" r="1.1" fill="currentColor" /><circle cx="14" cy="8" r="1.1" fill="currentColor" /></svg>
);
// Embed — code brackets
export const IcoEmbed = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M8 8l-4 4 4 4M16 8l4 4-4 4M13.5 6l-3 12" /></svg>
);
// Transparency / pricing — receipt
export const IcoReceipt = ({ size = 24 }: P) => (
  <svg {...base(size)}><path d="M6 3h12v18l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4L6 21z" /><path d="M9 8h6M9 12h6" /></svg>
);

export const Arrow = ({ size = 15 }: P) => (
  <svg className="sgk-arrow" width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h13M13 6l6 6-6 6" />
  </svg>
);

export const ICONS = {
  donations: IcoDonations, applications: IcoApplications, scoring: IcoScoring,
  disbursement: IcoDisbursement, compliance: IcoCompliance, footprint: IcoFootprint,
  site: IcoSite, theming: IcoTheming, embed: IcoEmbed, receipt: IcoReceipt,
} as const;
export type IconKey = keyof typeof ICONS;
